import { useApolloClient } from '@apollo/client';
import { useEffect } from 'react';

import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { GetVitaLatestDocumentDocument } from '@xing-com/crate-lebenslauf-graphql';
import {
  convertNullValues,
  removeTypename,
} from '@xing-com/crate-lebenslauf-helpers';
import {
  sharedClientDocumentVariable,
  vitaClientDocumentInitialValues,
} from '@xing-com/crate-lebenslauf-shared-client-document-variable';

export const useLastDocument = (): void => {
  const client = useApolloClient();
  const { isLoggedIn } = useLoginState();

  const handleLocalDocument = (): void => {
    const localDocument =
      global?.window?.localStorage?.getItem('vita-document');
    localDocument && sharedClientDocumentVariable(JSON.parse(localDocument));
  };

  const fetchLastDocument = async (): Promise<void> => {
    try {
      const { data } = await client.query({
        query: GetVitaLatestDocumentDocument,
      });

      const loggedInDocument = data?.viewer?.vitaLatestDocument;

      if (loggedInDocument && loggedInDocument.__typename === 'VitaDocument') {
        sharedClientDocumentVariable({
          ...vitaClientDocumentInitialValues,
          ...removeTypename(convertNullValues(loggedInDocument)),
        });
      } else {
        console.error({ loggedInDocument });
        handleLocalDocument();
      }
    } catch (error) {
      console.error(error);
      handleLocalDocument();
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      fetchLastDocument();
    } else {
      handleLocalDocument();
    }
  }, [client, isLoggedIn]);
};
